import * as OmValidationMessageHelper from '../helpers/validation-message-helper.js';
import { DAYS_IN_MONTHS, mapToDateParts } from '../helpers/validation-date-helper.js';
import { config } from '../config/index.js';
import { getAccurateAge } from './date-of-birth-validator.js';

function isYearEarlierThan1850(date) {
    return date.year < 1850;
}
export const VALIDATION_VARIANT={
    MONTHLY:'month',
    YEARLY:'year',
    WEEKLY:'week'
}
function isFutureDate(dob) {
    const dobObj = new Date(dob.year, dob.month - 1, dob.day);
    const today = new Date();
    return today.getTime() - dobObj.getTime() < 0;
}

function validateDate(date) {
    const validDay = validateDay(date);
    const validMonth = validateMonth(date);
    const validYear = validateYear(date);

    if (!validDay || !validMonth || !validYear) {
        return false;
    }

    return true;
}

function validateDay(date) {
    const month = date.month;
    const day = date.day;
    const year = date.year;

    if (isNaN(day)) {
        return false;
    }

    // Change Feb days if it is leap year
    if (year % 4 === 0 && month === 2 && day === 29) {
        return true;
    }

    if (day > DAYS_IN_MONTHS[month - 1] || day <= 0) {
        return false;
    }

    return true;
}

function validateMonth(date) {
    const month = date.month;

    if (isNaN(month)) {
        return false;
    }

    return month <= 12 && month > 0;
}

function validateYear(date) {
    const year = date.year;

    if (isNaN(year)) {
        return false;
    }

    return year > 0;
}

// Date of birth validation according to weeks
export const validateDateOfBirthByWeeks = (
    value,
    {
        min,
        max,
        minVariant = VALIDATION_VARIANT.WEEKLY,
        maxVariant = VALIDATION_VARIANT.WEEKLY,
        subject = 'Date of birth',
        required = true,
        pronoun = config.PRONOUN.YOUR,
        retainSubjectCase,
    } = {}
) => {
    function mapDates(value) {
        const parts = value.split('/');

        try {
            if (parts[2] && parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4) {
                return {
                    day: parseInt(parts[0], 10),
                    month: parseInt(parts[1], 10),
                    year: parseInt(parts[2], 10),
                };
            }
        } catch (e) {
            // Null will be returned on error
        }

        return null;
    }
    if (!value && required) {
        return OmValidationMessageHelper.getRequiredMessage(subject, retainSubjectCase);
    }

    if (!value && !required) {
        return null;
    }

    const date = mapDates(value);

    if (!date) {
        return OmValidationMessageHelper.DATE_FORMAT_ERROR;
    }

    if (!validateDate(date)) {
        return OmValidationMessageHelper.DATE_FORMAT_ERROR;
    }

    if (isFutureDate(date)) {
        return OmValidationMessageHelper.getDateOfBirthNotAllowedMsg(pronoun, retainSubjectCase);
    }

    if (isYearEarlierThan1850(date)) {
        return OmValidationMessageHelper.DATE_OF_BIRTH_NOT_ALLOWED_ERROR;
    }

    let tooYoungMessege =OmValidationMessageHelper.getTooYoungMsgMonthly(min, pronoun, minVariant, retainSubjectCase);
    let tooOldMessege =OmValidationMessageHelper.getTooOldMsgMonthly(max + 1, pronoun, maxVariant, retainSubjectCase);

    const ageVariant={
        [VALIDATION_VARIANT.WEEKLY]: calculateAgeInWeeks,
        [VALIDATION_VARIANT.MONTHLY]: calculateAgeInMonths,
        [VALIDATION_VARIANT.YEARLY]: ()=> getAccurateAge(date)
            // const[day,month,year]=value.split('/') 

    }

    // if (variant === 'weekly') {
    //     tooYoungMessege =
    //         min >= 52
    //             ? OmValidationMessageHelper.getTooYoungMsg(Math.trunc(min / 52), pronoun, retainSubjectCase)
    //             : OmValidationMessageHelper.getTooOldMsgWeekly(min, pronoun, retainSubjectCase);
    //     tooOldMessege =
    //         max >= 52
    //             ? OmValidationMessageHelper.getTooOldMsgBw(Math.trunc(max / 52), pronoun, retainSubjectCase)
    //             : OmValidationMessageHelper.getTooOldMsgWeekly(max, pronoun, retainSubjectCase);
    // } else if (variant === 'monthly') {
    //     tooYoungMessege =
    //         min >= 12
    //             ? OmValidationMessageHelper.getTooYoungMsg(Math.trunc(min / 12), pronoun, retainSubjectCase)
    //             : OmValidationMessageHelper.getTooYoungMsgMonthly(min, pronoun, retainSubjectCase);
    //     tooOldMessege =
    //         max >= 12
    //             ? OmValidationMessageHelper.getTooOldMsgBw(Math.trunc(max / 12), pronoun, retainSubjectCase)
    //             : OmValidationMessageHelper.getTooOldMsgMonthly(max, pronoun, retainSubjectCase);
    // }

    const minAge = ageVariant[minVariant](value)
    // minVariant === 'monthly' ? calculateAgeInMonths(value) : calculateAgeInWeeks(value);
    const maxAge =ageVariant[maxVariant](value)
    //  maxVariant === 'monthly' ? calculateAgeInMonths(value) : calculateAgeInWeeks(value);
console.log(minAge,minAge);
    if (min && minAge < min) {
        return tooYoungMessege;
    }
    if (max && maxAge > max) {
        return tooOldMessege;
    }

    return null;
};
function calculateAgeInMonths(dobStr){
    {
        // Split the date string into day, month, and year
        let [day, month, year] = dobStr.split('/').map(Number);
        
        // Create a date object for the date of birth
        let dob = new Date(year, month - 1, day); // Month is zero-based in JavaScript Date
    
        // Get the current date
        let currentDate = new Date();
    
        // Check if the date of birth is in the future
        if (dob > currentDate) {
            return 0; // Return 0 if the person is not born yet
        }
    
        // Calculate the difference in years and months
        let yearsDiff = currentDate.getFullYear() - dob.getFullYear();
        let monthsDiff = currentDate.getMonth() - dob.getMonth();
        
        // If the current day is earlier than the birth day in the same month, do not count the month
        if (currentDate.getDate() < day) {
            monthsDiff -= 1;
        }
        
        // Adjust if the current month is earlier than the birth month
        if (monthsDiff < 0) {
            yearsDiff -= 1;
            monthsDiff += 12;
        }
    
        // Total months = years * 12 + months
        let totalMonths = yearsDiff * 12 + monthsDiff;
        return totalMonths;
    }
}

function calculateAgeInWeeks(dobStr) {
    // Split the input string by "/" to extract day, month, and year
    const [day, month, year] = dobStr.split('/').map(Number);

    // Create a Date object for the date of birth
    const dob = new Date(year, month - 1, day);

    // Get the current date
    const today = new Date();

    // Calculate the difference in time (in milliseconds)
    const diffInMs = today - dob;

    // Convert milliseconds to days
    const ageInDays = diffInMs / (1000 * 60 * 60 * 24);

    // Convert days to weeks
    const ageInWeeks = Math.floor(ageInDays / 7);

    return ageInWeeks;
}

function formatted(date = new Date()) {
    return [date.getFullYear(), short(date.getMonth() + 1), short(date.getDate())].join('-');
}
function short(num) {
    return num.toString().padStart(2, '0');
}


// function calculateAgeInMonths(dobStr) {
//     // Split the input string by "/" to extract day, month, and year
//     const [day, month, year] = dobStr.split('/').map(Number);

//     // Create a Date object for the date of birth
//     const dob = new Date(year, month - 1, day);

//     // Get the current date
//     const today = new Date();

//     // Calculate the difference in time
//     let ageInYears = today.getFullYear() - dob.getFullYear();
//     let ageInMonths = today.getMonth() - dob.getMonth();

//     // Adjust if the current month is earlier than the birth month
//     if (ageInMonths < 0) {
//         ageInYears--;
//         ageInMonths += 12; // Adjust months
//     }

//     // Total months calculation
//     const totalAgeInMonths = ageInYears * 12 + ageInMonths;

//     return totalAgeInMonths;
// }